
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLogAddGoogle as ObiLogAddGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-log-add-google.js';
 
 
 

 
 export const ObiLogAddGoogle = createComponent({
   react: React,
   tagName: 'obi-log-add-google',
   elementClass: ObiLogAddGoogleElement,
   events: {
     
   }
  });
 
 